import styled from 'styled-components';

export const LogoContainer = styled.div`
  svg {
    width: 64px;
  }
`;
